// Turns any axios/FastAPI error into a safe string for toasts (422 detail is an array of objects).
export function apiErrorMessage(err, fallback = "Errore") {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) {
    return d.map((e) => {
      const field = Array.isArray(e?.loc) ? e.loc.slice(1).join(".") : "";
      return field ? `${field}: ${e?.msg || ""}` : e?.msg || JSON.stringify(e);
    }).join(" · ") || fallback;
  }
  if (typeof d === "object") return d.msg || JSON.stringify(d);
  return fallback;
}
